module.exports = __webpack_public_path__ + "img/00043.94709a66.webp";